import Mark from "./Mark.ts";
import IMark from "../interfaces/IMark.ts";
import MarkText from "../components/MarkText.ts";
import DecodingModel from "../models/DecodingModel.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import {ColorOverlayFilter} from "pixi-filters";
import ColorUtil from "../utils/ColorUtil.ts";
import RhColors from "@/models/RhColors.ts";

export default class GuardianMark extends Mark implements IMark
{
    private isRainbow:boolean;
    private letters:string;
    private model:DecodingModel;

    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY, letterCount:number=1, letters:string="", isRainbow:boolean=false)
    {
        super(color);
        this.targetTextField = targetTextField;
        this.letters = letters;
        this.isRainbow = isRainbow;
        this._init(letterCount);
    }

    private _init(letterCount:number):void
    {
        this.model = DecodingModel.getInstance();
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
            this.targetTextFieldStyle = this.targetTextField.style;
            this.markX = this.targetTextField.width/2;
            if(letterCount == 2)
            {
                if(this.hasAscenderTwoLetters(this.letters))
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(110)*this.multipleOfDefaultFontSize);
                }
                else
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(36)*this.multipleOfDefaultFontSize);
                }
            }
            else if(letterCount == 3)
            {
                if(this.hasAscenderThreeLetters(this.letters))
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(110)*this.multipleOfDefaultFontSize);
                }
                else
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(36)*this.multipleOfDefaultFontSize);
                }
            }
            else
            {
                if(this.hasAscender(this.targetTextField.text))
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(115)*this.multipleOfDefaultFontSize);
                }
                else
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(70)*this.multipleOfDefaultFontSize);
                }
            }
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        let mark = Sprite.from("guardianstar");
        const colorOverlay = new ColorOverlayFilter({color:ColorUtil.hexHashStringToNumber(color)});
        mark.filters = [colorOverlay];
        if(this.targetTextField)
        {
            if(this.isRainbow)
            {
                if(this.letters == "j")
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(190)*this.multipleOfDefaultFontSize);
                    mark.scale.set(.54);
                }
                else
                {
                    this.markY = this.targetTextField.height/2-(this.adjustToScale(160)*this.multipleOfDefaultFontSize);
                    mark.scale.set(.54);
                }
            }
            else
            {
                mark.scale.set(this.multipleOfDefaultFontSize);
            }
        }
        else
        {
            mark.scale.set(this.textScale);
        }
        //mark.cacheAsBitmap = true;
        mark.visible = visible;
        this.addChild(mark);
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markWidth = this.mark.width;
        this.markHeight = this.mark.height;
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

    public override destroy():void
    {
        this.model = null;
        super.destroy();
    }
}